import React from 'react';

import { Row } from 'antd';
import { useTranslation } from 'react-i18next';

import baner from '../../assets/support-baner.png';

import './style.scss';

const Support = () => {
  const { t } = useTranslation('');

  return (
    <div className="support profile-wrap" style={{ position: 'relative' }}>
      <Row className="support-header-wrap">
        <h2 className="support-title">{t('SUPPORT_LC')}</h2>
      </Row>
      <div className="client baner-wrapper">
        <img className="support-baner" src={baner} alt="baner" />
        <div>
          <div className="suport-text-wrapper">
            <div className="suport-text-block-left">
              <h2 className="">{t('PLEASE_CONTACT_CITRONEER')}</h2>
            </div>
            <div className="suport-text-block-right">
              <div>
                <p className="support-label">{t('EMAIL').toUpperCase()}</p>
                <a href="mailto:support@lifetiming.ai" className="support-text">
                  support@lifetiming.ai
                </a>
              </div>
            </div>
          </div>
          <div className="suport-text-wrapper">
            <div className="suport-text-block-left">
              <h2 className="">{t('VISIT_OUR_JIRA_PORTAL')}</h2>
            </div>
            <div className="suport-text-block-right">
                <a href="https://lifetiminganalytics.atlassian.net/servicedesk/customer/portal/1 " target='_blank' rel="noreferrer" className="support-text download">
                  {t('LIFETIMING_JIRA_PORTAL')}
                </a>
            </div>
          </div>
          <div className="suport-text-wrapper">
            <div className="suport-text-block-left">
              <h2 className="">{t('TO_DOWNLOAD')}</h2>
            </div>
            <div className="suport-text-block-right">
                <a href="/tmp/LA Manual - MASTER (06_27).pdf" download className="support-text download">
                  {t('LIFETIMING_MANUAL')}
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
